import theme from '@styles/theme';
export default {
  section: {
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    height: ['138.666667vw', '138.666667vw', '73.3072917vw', '73.3072917vw', '46.875vw']
  },
  imageHolder: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    img: {
      transition: 'opacity .15s',
      height: '100%',
      width: '100%'
    }
  },
  contentHolder: {
    height: '100%',
    width: '100%',
    position: 'absolute'
  },
  content: {
    top: ['calc((138.666667vw/2) - 48px)', 'calc((138.666667vw/2) - 48px)', 'calc((73.3072917vw/2) - 63px)', 'calc((73.3072917vw/2) - 63px)', 'calc((46.875vw/2) - 98px)'],
    pb: [91, 91, 91, 91, 100],
    position: 'sticky'
  },
  styledHeading: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    alignItems: 'flex-start',
    width: 'fit-content',
    height: 'fit-content',
    pl: ['10.6666667vw', '8.33333333vw', '8.33333333vw', '10.7638889vw', '10.7638889vw', '10.15625vw'],
    m: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    textTransform: 'none',
    textShadow: 'none'
  },
  headerText: (color: string, bgColor: string) => ({
    display: 'block',
    width: 'fit-content',
    height: 'fit-content',
    textTransform: 'uppercase',
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    lineHeight: '100%',
    fontSize: [theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h3],
    letterSpacing: theme.letterSpacings.bigCaps,
    textShadow: '0px 0px 20px rgba(0, 0, 0, 0.25)',
    color: color || theme.rawColors.neutralWhite,
    backgroundColor: bgColor || 'transparent',
    ...(bgColor && {
      p: ['16px 16px 16px 0', '16px 16px 16px 0', '16px 16px 16px 0', '24px 24px 24px 0', '24px 24px 24px 0', '24px 24px 24px 0']
    })
  }),
  subHeaderText: (color: string, bgColor: string) => ({
    display: 'block',
    width: 'fit-content',
    height: 'fit-content',
    textTransform: 'uppercase',
    fontFamily: theme.fonts.uniformExtra,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '100%',
    fontSize: [theme.fontSizes.smallHeading, theme.fontSizes.smallHeading, theme.fontSizes.displayOneTablet, theme.fontSizes.displayOneTablet, theme.fontSizes.displayOne],
    letterSpacing: theme.letterSpacings.caps,
    textShadow: '0px 0px 40px rgba(0, 0, 0, 0.25)',
    color: color || theme.rawColors.neutralWhite,
    backgroundColor: bgColor || 'transparent',
    ...(!bgColor && {
      ml: ['-3px', '-3px', '-3px', '-3px', '-7px']
    }),
    ...(bgColor && {
      p: ['16px', '16px', '16px', '16px', '24px']
    })
  })
};